import JSEncrypt from "jsencrypt";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PUBLIC_KEY } from "../utils/constants";
import { generateHash } from "../service";
import { loginAPI } from "../service/AuthService";
import toast from "react-hot-toast";
import Loader from "./Loader";

export default function LoginPopUp({
  login,
  isLoginPopUpOpen,
  setIsLoginPopUpOpen,
  isAutoLogin,
  isLoading,
  setLoading,
}) {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const counter = sessionStorage?.getItem("counter");

  /* useEffect(() => {
    if (isAutoLogin && password && userName) {
      login(userName, password);
    }
   
  }, [password, userName, isAutoLogin]); */

  return (
    <div
      style={{
        zIndex: 1000,
        marginTop: location.pathname != "/" ? "-10px" : "0px",
      }}
      _ngcontent-ng-c75588018=""
      className="main-Box-login"
    >
      {isLoading && <Loader />}
      {location.pathname == "/" && (
        <div onClick={() => setIsLoginPopUpOpen(false)}>
          <a
            _ngcontent-ng-c75588018=""
            routerlink="/home"
            className="crossIcon"
          >
            <i _ngcontent-ng-c75588018="" className="fas fa-times" />
          </a>
        </div>
      )}
      <div _ngcontent-ng-c75588018="" className="centered-container">
        <div
          _ngcontent-ng-c75588018=""
          className="loginlogo"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            _ngcontent-ng-c75588018=""
            alt=""
            src="/assets/images/logo.png"
          />
        </div>
        <div _ngcontent-ng-c75588018="" className="mt-4">
          <div
            _ngcontent-ng-c75588018=""
            noValidate=""
            className="ng-pristine ng-invalid ng-touched"
          >
            <div _ngcontent-ng-c75588018="" className="mb-4">
              <div
                _ngcontent-ng-c75588018=""
                className="d-flex align-items-center phoneNumberDiv"
                style={{ position: "relative" }}
              >
                <input
                  _ngcontent-ng-c75588018=""
                  type="text"
                  autofocus=""
                  tabIndex={1}
                  required=""
                  name="userName"
                  value={userName}
                  onChange={(e) => setUsername(e.target.value)}
                  id="userName"
                  placeholder="Username"
                  className="form-control phoneNumberInput ng-pristine ng-invalid ng-touched"
                  maxLength={30}
                />
                <button
                  _ngcontent-ng-c75588018=""
                  type="button"
                  className="btn btn-outline-secondary showPasswordbtn"
                  style={{ border: "none" }}
                >
                  <i
                    _ngcontent-ng-c75588018=""
                    className="fa fa-user inputicon fa-lg user-icon"
                  />
                </button>
              </div>
            </div>
            <div _ngcontent-ng-c75588018="" className="mb-4">
              <div _ngcontent-ng-c75588018="" className="d-flex phoneNumberDiv">
                <input
                  _ngcontent-ng-c75588018=""
                  tabIndex={2}
                  required=""
                  minLength={6}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  /*  onInput={(e) => {
                    if (e.nativeEvent.inputType === undefined && !counter) {
                      login(userName, e.target.value);
                    }
                  }} */
                  /*   onBlur={() => {
                    if (password.length > 4) {
                      login(userName, password);
                    }
                  }} */
                  id="password"
                  name="password"
                  placeholder="Password"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      login(userName, password);
                    }
                  }}
                  className="form-control phoneNumberInput ng-untouched ng-pristine ng-invalid"
                  type={showPassword ? "text" : "password"}
                />
                <button
                  _ngcontent-ng-c75588018=""
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="btn btn-outline-secondary showPasswordbtn"
                  style={{ border: "none" }}
                >
                  {
                    <i
                      _ngcontent-ng-c75588018=""
                      className={`fa ${
                        !showPassword ? "fa-eye-slash" : "fa-eye"
                      } inputicon fa-lg`}
                    />
                  }
                </button>
              </div>
              {/**/}
            </div>
            <div _ngcontent-ng-c75588018="">
              <button
                onClick={() => {
                  setLoading(true);
                  login(userName, password);
                }}
                disabled={isLoading}
                _ngcontent-ng-c75588018=""
                type="submit"
                className="btn-send ui-link loginBtn"
              >
                Login
              </button>
              <button
                onClick={() => {
                  setLoading(true);
                  login(userName, password, true);
                }}
                _ngcontent-ng-c75588018=""
                type="button"
                className="btn-send ui-link loginBtn mt-1 disablebtn"
              >
                Login with Demo ID
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
